import { render, staticRenderFns } from "./InviteSignUp.vue?vue&type=template&id=072e1b37&scoped=true&lang=pug&"
import script from "./InviteSignUp.vue?vue&type=script&lang=js&"
export * from "./InviteSignUp.vue?vue&type=script&lang=js&"
import style0 from "./InviteSignUp.vue?vue&type=style&index=0&id=072e1b37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072e1b37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VForm,VLayout,VTextField})
